import React from 'react';

import AddUserPopout from 'components/add-user-popout';
import UserFaces from 'components/user-faces';
import Tooltip from 'components/tooltip';

import IconInvite from 'icons/icon-invite';

const UsersList = ({ users, size, className, subtitles, maxUsersCount, border, onSubtitleClick, editable, popoutTitle, projectId, roles, predefinedUsers, emailMatchText, noMatchText, popoutSize, excludedUsers, closeOnEveryClick, onUserSelect, addUserTooltip, btnClassName, btnTooltip, addUserText, addUserIcon, onAddUserClick }) => {

    return (
        <div className={'users-list-component users-list-component-' + size + ' ' + className}>
            {
                users?.length ? (
                    <UserFaces
                        users={users}
                        size={size}
                        subtitles={subtitles}
                        maxUsersCount={(editable || onAddUserClick) ? maxUsersCount - 1 : maxUsersCount}
                        border={border}
                        onSubtitleClick={onSubtitleClick}
                    />
                ) : null
            }

            {
                editable || onAddUserClick ? (
                    <div className="add-user">
                        {
                            onAddUserClick ? (
                                <Tooltip tooltip={addUserTooltip} disabled={!addUserTooltip}>
                                    <button className={btnClassName} onClick={onAddUserClick}>
                                        { addUserText || addUserIcon || <IconInvite /> }
                                    </button>
                                </Tooltip>
                            ) : (
                                <AddUserPopout
                                    title={popoutTitle}
                                    projectId={projectId}
                                    roles={roles}
                                    predefinedUsers={predefinedUsers}
                                    emailMatchText={emailMatchText}
                                    noMatchText={noMatchText}
                                    size={popoutSize}
                                    excludedUsers={excludedUsers}
                                    closeOnEveryClick={closeOnEveryClick}
                                    onUserSelect={onUserSelect}
                                >
                                    <span>
                                        <Tooltip tooltip={addUserTooltip} disabled={!addUserTooltip}>
                                            <span className={btnClassName} data-tooltip={btnTooltip}>
                                                { addUserText || addUserIcon || <IconInvite /> }
                                            </span>
                                        </Tooltip>
                                    </span>
                                </AddUserPopout>
                            )
                        }
                    </div>
                ) : null
            }
        </div>
    )
}

UsersList.defaultProps = {
    className: '',
    btnClassName: 'btn btn-action btn-colored'
};

export default UsersList;
